<template>
  <div class="formWrapper filled">
    <div class="form-header floatCss">
      <b-row>
        <b-col cols="12">
          <div class="form-header-inner d-flex justify-content-between">
            <div class="d-flex">
              <div class="dForm-top-logo">
                <img :src="logoSrc">
              </div>
              <div class="dForm-companyDetails">
                <div class="dForm-cmBlock">
                  <h2>
                    富貴山莊<br>Mount Prajna Ltd.
                  </h2>
                </div>
                <div class="dForm-cmBlock2">
                  <p>(Co. Reg. No. 200401183W)</p>
                  <p>(GST Group Reg. No. M90364395L)</p>
                </div>
              </div>
            </div>
            <div class="dForm-top-right d-flex">
              <h5 class="text-block">
                REV:3
              </h5>
              <h5>File No: 68U000287</h5>
              <h5>Sales Order No: {{ formData.orderNo || 'G-12345-AT' }}</h5>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="pp-section-tittle">
            <h2>installment payment plan 分期付款计划</h2>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row class="payment-plan-section">
      <b-col cols="12">
        <b-row class="pp-wrapper-row font-pdf-custom">
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block floatCss">
              <div class="pp-nt-text pp-nt-wd-1 floatCss">
                I,
              </div>
              <div class="pp-nt-text-input pp-nt-wd-2">
                {{ formData.customerName || '-' }}
              </div>
            </div>
          </b-col>
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block-container floatCss">
              <div class="pp-nt-block floatCss">
                <div class="pp-nt-text pp-nt-wd-2 floatCss">
                  NRIC No.
                </div>
                <div class="pp-nt-text-input pp-nt-wd-3">
                  {{ formData.customerNric || '-' }}
                </div>
              </div>
              <div class="pp-nt-text3">
                the purchaser of
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-wrapper-row font-pdf-custom">
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block floatCss">
              <div class="pp-nt-text pp-nt-wd-a1 floatCss">
                Sales Order No.
              </div>
              <div class="pp-nt-text-input pp-nt-wd-a2">
                {{ formData.orderNo || 'N-12345' }}
              </div>
            </div>
          </b-col>
          <b-col
            cols="6"
            md="6"
            lg="6"
          >
            <div class="pp-nt-block floatCss">
              <div class="pp-nt-text pp-nt-wd-2 floatCss">
                Niche No.
              </div>
              <div class="pp-nt-text-input pp-nt-wd-2">
                {{ formData.nicheNo || '-' }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-wrapper-row font-pdf-custom">
          <b-col cols="12">
            <div class="pp-single-row floatCss">
              <div class="pp-single-sd1">
                do hereby request for the balance of the purchase prices to be settled by an installment plan.
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-check-wrapper">
          <b-col cols="12">
            <div class="pp-section-tittle2">
              <h2>mode of payment</h2>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="pp-check-group">
              <div class="pp-check-single">
                Via Counter or Mobile App
              </div>
              <div class="pp-check-single">
                Direct Debit via Credit Card
              </div>
              <div class="pp-check-single">
                Credit Card IPP
              </div>
              <div class="pp-check-single">
                Giro or eGiro
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="instalment-details-section">
          <b-col cols="12">
            <div class="pp-section-tittle2">
              <h2>Installment Plan Details</h2>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="pp-instalment-wrapper floatCss">
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Installment Plan Amount (SGD)
                </div>
                <div class="instalment-right-input floatCss">
                  ${{ numberFormat(formData.installmentAmount) }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Installment Tenure
                </div>
                <div class="instalment-right-input floatCss">
                  {{ formData.installmentTenure }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Monthly Installment Amount
                </div>
                <div class="instalment-right-input floatCss">
                  ${{ numberFormat(formData.monthlyInstallment) }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Final Installment Amount
                </div>
                <div class="instalment-right-input floatCss">
                  ${{ numberFormat(formData.finalInstallment) }}
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss">
                  Installment Due Date
                </div>
                <div class="instalment-right-content floatCss">
                  <div class="pp-instalment-single2 floatCss">
                    <div class="pp-instalment-tittle-2 floatCss">
                      Commencing on 1st day of
                    </div>
                    <div class="instalment-right-input2 floatCss">
                      {{ formData.commencingDate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="pp-instalment-single floatCss">
                <div class="instalment-left-tittle floatCss" />
                <div class="instalment-right-content floatCss">
                  <p>and thereafter on the 1st day of each month</p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-intalment-text">
          <b-col cols="12">
            <div class="pp-bottom-info-text">
              <p>I hereby agree that the terms and conditions contains in the Sales Order remains unchanged and the Company reserved the sole right in amending or rejecting the Installment Plan without assigning any reason thereto.</p>
            </div>
          </b-col>
        </b-row>
        <b-row class="pp-service-text">
          <b-col cols="12">
            <div class="pp-section-tittle2">
              <h2>PARTICULARS of service advisor  服务顾问资料</h2>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="service-pp-info floatCss">
              <div class="service-pp-left-info">
                Agency 区代理
              </div>
              <div class="service-pp-right-info">
                {{ formData.agency }}
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="service-pp-info floatCss">
              <div class="service-pp-left-info">
                Service Advisor 服务顾问
              </div>
              <div class="service-pp-right-info">
                {{ formData.serviceAdvisor }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="footer-signature-area">
          <b-col cols="12">
            <div class="pp-signature-area floatCss">
              <p>Purchaser 购买者签名</p>
            </div>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col
                cols="6"
                md="6"
                lg="6"
              >
                <div class="pp-signature-block floatCss">
                  <img
                    v-if="formData.sign"
                    :src="formData.sign"
                    alt="signature"
                  >
                  <span v-else>Sign here</span>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <div
              class="pp-signature-area floatCss"
            >
              <h4>Name 姓名: {{ formData.customerName }}</h4>
              <h4>Date 日期: {{ formData.sign ? dateFormat() : '' }}</h4>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: JSON.parse(localStorage.getItem('installmentFormData')) || {},
    }
  },
}
</script>
